export const domain = '/api/'
export const pre_imageUrl = 'https://deportal.mmais.com.cn'